/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Configuration of the import
 */
export type PublicConfigurationImportDto = {
    /**
     * Type of external catalog. If not listed, use CATALOG_GENERIC
     */
    catalogProvider: PublicConfigurationImportDto.catalogProvider;
};

export namespace PublicConfigurationImportDto {

    /**
     * Type of external catalog. If not listed, use CATALOG_GENERIC
     */
    export enum catalogProvider {
        ATLAN = 'ATLAN',
        ALATION = 'ALATION',
        AMUNDSEN = 'AMUNDSEN',
        APACHE_ATLAS = 'APACHE_ATLAS',
        CASTOR_DOC = 'CASTOR_DOC',
        COLLIBRA = 'COLLIBRA',
        DATAGALAXY = 'DATAGALAXY',
        INFORMATICA = 'INFORMATICA',
        SECODA = 'SECODA',
        SELECT_STAR = 'SELECT_STAR',
        CATALOG_GENERIC = 'CATALOG_GENERIC',
    }


}
